import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { LineChart } from "react-chartkick";
import "chartkick";

import { Page, Loadable, DataTable } from "components/support";

import Filter from "./filter";

class ProductSalesReportView extends Component {
  opcionalConfig = {
    identifier: "id",
    columns: [
      {
        id: "result.hour",
        accessor: result => result.hour + "h",
        Header: "Hora",
        align: "center",
        sortable: false
      },
      {
        id: "result.sales_count",
        accessor: result => result.sales_count,
        Header: "Quantidade Vendida",
        align: "center",
        sortable: false
      }
    ]
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, filters, pagination, product, user } = viewModel;
    const result = viewModel.result || [];
    const data = result.map(item => {
      return [item.hour + "h", item.sales_count];
    });
    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Vendas por Hora
        </Typography>

        <Filter
          loading={loading}
          filters={filters}
          product={product}
          user={user}
          onChange={filters => presenter.onFilterChange(filters)}
        />
        <Paper>
          <Row style={{ margin: "24px 0px 24px 0px", padding: 16 }}>
            <Col xs={12}>
              <LineChart ytitle="Quantidade" label="Vendas" data={data} />
            </Col>
          </Row>
        </Paper>

        <Loadable loading={loading}>
          <Paper elevation={1}>
            <Row>
              <Col xs={12}>
                <DataTable
                  manual
                  filterable={false}
                  resultSet={result}
                  total={pagination.total}
                  perPage={25}
                  page={1}
                  config={this.opcionalConfig}
                  onPageChange={page => presenter.onPageChange(page + 1)}
                />
              </Col>
            </Row>
          </Paper>
        </Loadable>
      </Page>
    );
  }
}

export default ProductSalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/hour-sales-report/view.jsx